angular.module('cvsApp').service('getUserOrderHistoryService',
	['networkService', 'xdrService', 'configManager', 'getUserOrderHistoryModel','cvsAppData', function (NS, XS,CM, OSM,CAD) {
   	
	function orderSummary (){
		this.orderSummaryData = function(callBackSuccess){
			//get url
            var tokenId= CAD.getTokenId();
            var tokenType= CAD.getTokenType();
			var apikey = CAD.getApiKey();
			var url = CM.getAPIUrlWithOtherInfo('GET_USER_ORDER_HISTORY', tokenId, CAD.getTokenType());
			
			if(url === "URL_ERROR"){

			}else{

				//var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
				var request = {url:url,
							header:{},
							data:requestBody(),
							onSuccess:callBackSuccess
						}
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, "", xdrSuccess);

					function xdrSuccess (data) {
						OSM.setResponse(data);
						callBackSuccess(OSM.getResponse());
					}
				}
				else {
					// console.log("reqqqqqq", request);
					var promise = NS.post(request);	
					promise.then(function(data, c, d){
						
						OSM.setResponse(data.data);
						callBackSuccess(OSM.getResponse());

					}, function(reason){
						callBackSuccess(NS.httpError(reason));
					});
				}
			}
							
		}


		var requestBody = function(){

			var tokenId =  CAD.getTokenId();
			var tokenType = CAD.getTokenType();
			var apikey = CAD.getApiKey();
			return {
					"getUserOrderHistoryRequest": {
						"standardRequest": {
						  	"clientTraceLevel": "1",
							"tokenID": tokenId,
							"tokenType": tokenType,
							"apikey": apikey
						}
					}
				}

		}


		this.setResponse = function(data){
			PQM.setResponse(data);		
		}	

		this.getResponse = function(){				
			return PQM.getResponse();		
		}	
	
	}
	
	return new orderSummary();	
}]);
